import TourListingPage from "../components/tours/TourListingPage";

export default function UpcomingToursPage() {
  return (
    <TourListingPage
      endpoint="tours/upcoming"
      title="Upcoming Tours"
      description="Explore your upcoming destinations, tour schedules, and travel details."
      icon="fa-plane-departure"
    />
  );
}
